import { useSyncExternalStore } from "react";
import { onPrefs, pushPref } from "@/lib/prefsSync";

/* Video playback preferences: smooth-buffer player on/off and how far ahead to buffer; synced to the account. */
const KEY = "rh.video";
export const AHEAD_OPTIONS = [[30, "30 s"], [60, "1 min"], [120, "2 min"], [180, "3 min"]];
export const DEFAULT = { smooth: true, ahead: 60, theater: false, autoplay: true, fit: "fit", smartCrop: true, fitByGroup: {} };
let state = DEFAULT;
try { state = { ...DEFAULT, ...JSON.parse(localStorage.getItem(KEY) || "{}") }; } catch { state = DEFAULT; }
const subs = new Set();
const emit = () => subs.forEach((fn) => fn());
const persist = (push) => { localStorage.setItem(KEY, JSON.stringify(state)); emit(); if (push) pushPref("video", state); };

onPrefs("video", {
  apply: (v) => { state = { ...DEFAULT, ...(v || {}) }; persist(false); },
  read: () => state,
});

export const useVideoPrefs = () => useSyncExternalStore((fn) => { subs.add(fn); return () => subs.delete(fn); }, () => state);
export const setVideoPref = (patch) => { state = { ...state, ...patch }; persist(true); };
export const getVideoPrefs = () => state;
